import * as Yup from 'yup'

const ProductBrandCreateSchema = Yup.object().shape({
  label           : Yup.string().required('Required'),
  classifications : Yup.string().required('Required')
})

export default ProductBrandCreateSchema